module.exports = __webpack_public_path__ + "static/medal-iccws-silver-59e5cf3241c02b19f35897e8e3d90c4d.png";